
    import './styles.scoped.css';
    export default {
  "flash-refresh": "awsui_flash-refresh_1q84n_h7c07_93",
  "enter": "awsui_enter_1q84n_h7c07_93",
  "flash-body": "awsui_flash-body_1q84n_h7c07_108",
  "flash-message": "awsui_flash-message_1q84n_h7c07_108",
  "flash-header": "awsui_flash-header_1q84n_h7c07_108",
  "flash-content": "awsui_flash-content_1q84n_h7c07_109",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_h7c07_110",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_h7c07_111",
  "flash-icon": "awsui_flash-icon_1q84n_h7c07_134",
  "entering": "awsui_entering_1q84n_h7c07_147",
  "entered": "awsui_entered_1q84n_h7c07_168",
  "exiting": "awsui_exiting_1q84n_h7c07_273",
  "flashbar": "awsui_flashbar_1q84n_h7c07_295",
  "flash": "awsui_flash_1q84n_h7c07_93",
  "flash-list": "awsui_flash-list_1q84n_h7c07_350",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_h7c07_386",
  "flash-text": "awsui_flash-text_1q84n_h7c07_392",
  "dismiss-button": "awsui_dismiss-button_1q84n_h7c07_111",
  "breakpoint-default": "awsui_breakpoint-default_1q84n_h7c07_433",
  "flash-list-item": "awsui_flash-list-item_1q84n_h7c07_433",
  "action-button": "awsui_action-button_1q84n_h7c07_110",
  "flash-type-success": "awsui_flash-type-success_1q84n_h7c07_446",
  "flash-type-error": "awsui_flash-type-error_1q84n_h7c07_450",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_h7c07_454",
  "flash-type-info": "awsui_flash-type-info_1q84n_h7c07_458",
  "stack": "awsui_stack_1q84n_h7c07_462",
  "expanded": "awsui_expanded_1q84n_h7c07_467",
  "collapsed": "awsui_collapsed_1q84n_h7c07_481",
  "item": "awsui_item_1q84n_h7c07_487",
  "visual-refresh": "awsui_visual-refresh_1q84n_h7c07_497",
  "flash-items": "awsui_flash-items_1q84n_h7c07_503",
  "toggle": "awsui_toggle_1q84n_h7c07_510",
  "icon": "awsui_icon_1q84n_h7c07_573"
};
  